import { AgGridColumnDef } from '@tassat/common-definitions';
import moment from 'moment';

import { formatEpochDate } from 'Lib/stringHelpers';

export interface IRowData {
    APIConnectionName: string;
    ClientId: string;
    ConfirmCode: string;
    PairingTime: moment.Moment;
}

export const getApiConnectionsColumnDefs = (isSecondaryApiConAllowed: boolean): AgGridColumnDef[] => {
    const columns: AgGridColumnDef[] = [
        {
            field: 'apiConnection.APIConnectionName',
            headerName: 'API Connection Name',
            flex: 1
        }
    ];

    if (isSecondaryApiConAllowed) {
        columns.push({
            field: 'apiUser.ApiKey',
            headerName: 'API Key',
            flex: 1
        });
    }

    columns.push(
        {
            field: 'apiConnection.ClientId',
            headerName: 'Client ID',
            flex: 1
        },
        {
            field: 'apiUser.APIConfirmCode',
            headerName: 'API Confirm Code',
            flex: 1
        },
        {
            field: 'apiUser.CreatedAt',
            headerName: 'Time of Pairing',
            valueFormatter: (params) => {
                return formatEpochDate(params.data.apiUser.CreatedAt);
            },
            flex: 1
        }
    );

    // TODO Update only for Fireblocks API Connections
    if (isSecondaryApiConAllowed) {
        columns.push({
            field: 'apiConnection.ClientId',
            cellRenderer: 'actionButtonsCellRenderer',
            headerName: 'Actions',
            cellRendererParams: {
                actionButtonOptions: {
                    hasDelete: true,
                    hasLock: false
                },
                isClient: true
            },
            menuTabs: [],
            flex: 1
        });
    }

    return columns;
};